<template>
	<div class="card-status">
		{{ patientNo }} Patients 
		<span v-if="action === 'all'">
		</span>
		<span v-else-if="action !== 'all' && !messageName">
			- {{ actionName }}
		</span>
		<span v-else>
			- '{{ actionName }}' on '{{ messageName }}'
		</span>
	</div>
</template>

<script>
import { getActionList } from './static'

/**
 * Renders a string for the no. of patients performing an action
 * for an Event or a certian message of that event
 */
export default {
	name: 'action-status',
	created() {
		this.actionList = getActionList()
	},
	props: {
		/**
		 * The number of patients 
		 * performing the action
		 */
		patientNo: {
			type: Number,
			default: 0,
			required: true
		},
		/**
		 * The action status value
		 * @values Patients, Opened, Got It, Learn More, No Action
		 */
		action: {
			type: String,
			default: 'all',
			required: true,
			validator: (actionValue) => (getActionList().map(action => action.status).includes(actionValue))
		},
		/**
		 * The name of message in the event
		 * for the action (optional)
		 */
		messageName: {
			type: String
		}
	},
	computed: {
		actionName() {
			return this.actionList.find(action => action.status === this.action).name
		}
	}
}
</script>

<style>
.card-status{
	font-size: 22px;
	font-weight: 500;
	color: #333333;
	padding-top: 14px;
}
</style>
